import { render, staticRenderFns } from "./EditEmailPasswordForm.vue?vue&type=template&id=4ef2532a"
import script from "./EditEmailPasswordForm.vue?vue&type=script&lang=js"
export * from "./EditEmailPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports